import Sidebar from "./component/Sidebar";
import { AuthProvider, useAuth } from "./auth/authProvider.jsx";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import Dashboard from "./pages/Dashboard";
import SignupPage from "./auth/Signup";
import Blogs from "./blogs/Blogs.jsx";
import BlogEdit from "./pages/BlogEdit";
import ContactList from "./component/ContactList.jsx";
export default function App() {
  return (
    <AuthProvider>
      <Router>
        <MainLayout />
      </Router>
    </AuthProvider>
  );
}

const MainLayout = () => {
  const { isAuthenticated, loading } = useAuth();
  console.log("isAuthenticated:", isAuthenticated, "loading:", loading);

  if (loading) {
    return (
      <div className="h-screen flex justify-center items-center text-5xl">
        Loading...
      </div>
    );
  }

  if (!isAuthenticated) {
    return <SignupPage />;
  }

  return (
    <div className="flex">
      <div className="">
        <Sidebar />
      </div>
      <div className="flex-1 p-4 ml-[272px] h-screen bg-gray-50">
        <Routes>
          <Route path="/" element={<Navigate to="/dashboard" />} />
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/blogs" element={<Blogs />} />
          <Route path="/blog/edit/:id" element={<BlogEdit />} />
          <Route path="/contactlist" element={<ContactList />} />
        </Routes>
      </div>
    </div>
  );
};
